const PRIVATE_MEMBER_INVITATION_KEYS = [
  "targetTeamId",
  "inviterId",
  "inviteSource",
];

export const OFFICIAL_SITE_SHARE_SOURCE = "OFFICIAL_SITE_SHARE";

const getSessionStorage = () => {
  if (typeof window === "undefined") return null;

  try {
    return window.sessionStorage;
  } catch (error) {
    return null;
  }
};

const normalizeTeamId = (value) => {
  const teamId = String(value || "").trim();
  return teamId && !["null", "undefined"].includes(teamId.toLowerCase())
    ? teamId
    : "";
};

const normalizeInviterId = (value) => {
  const rawValue = String(value || "").trim();
  if (!/^\d+$/.test(rawValue)) return null;

  const inviterId = Number(rawValue);
  return Number.isSafeInteger(inviterId) && inviterId > 0 ? inviterId : null;
};

export const clearPrivateMemberInvitation = () => {
  const storage = getSessionStorage();
  if (!storage) return;

  PRIVATE_MEMBER_INVITATION_KEYS.forEach((key) => storage.removeItem(key));
};

export const savePrivateMemberInvitation = ({
  targetTeamId,
  inviterId,
  source = OFFICIAL_SITE_SHARE_SOURCE,
} = {}) => {
  const storage = getSessionStorage();
  if (!storage) return null;

  const normalizedTeamId = normalizeTeamId(targetTeamId);
  const normalizedInviterId = normalizeInviterId(inviterId);
  const normalizedSource = String(source || "").trim();
  if (!normalizedTeamId || !normalizedInviterId || !normalizedSource) {
    clearPrivateMemberInvitation();
    return null;
  }

  storage.setItem("targetTeamId", normalizedTeamId);
  storage.setItem("inviterId", String(normalizedInviterId));
  storage.setItem("inviteSource", normalizedSource);

  return {
    targetTeamId: normalizedTeamId,
    inviterId: normalizedInviterId,
    source: normalizedSource,
  };
};

export const getPrivateMemberInvitation = () => {
  const storage = getSessionStorage();
  if (!storage) return null;

  const targetTeamId = normalizeTeamId(storage.getItem("targetTeamId"));
  const inviterId = normalizeInviterId(storage.getItem("inviterId"));
  const source = String(storage.getItem("inviteSource") || "").trim();
  if (!targetTeamId || !inviterId || !source) return null;

  return { targetTeamId, inviterId, source };
};

export const getPrivateMemberInvitationForTeam = (teamId) => {
  const invitation = getPrivateMemberInvitation();
  const normalizedTeamId = normalizeTeamId(teamId);
  return invitation && invitation.targetTeamId === normalizedTeamId
    ? invitation
    : null;
};

export const clearPrivateMemberInvitationForTeam = (teamId) => {
  if (getPrivateMemberInvitationForTeam(teamId)) {
    clearPrivateMemberInvitation();
  }
};
